import GameWrapper from "@/components/GameWrapper";
import NetworkStatusText from "@/components/NetworkStatusText/intex";
import GameProgressBar from "../../GameProgressBar";
import { Unity } from "react-unity-webgl";
import UseDevicePixelRatio from "@/hooks/UseDevicePixelRatio";
import { useBackgammonSpectator } from "../../hooks";

interface Props {
	matchID: string;
	clientId: string;
}

function SpectatorView({ clientId, matchID }: Props) {
	const { isLoaded, loadingPercentage, unityProvider, isConnected } =
		useBackgammonSpectator({
			matchID,
			clientId,
		});
	const { devicePixelRatio } = UseDevicePixelRatio();
	return (
		<GameWrapper isSpect>
			{isLoaded && !isConnected && (
				<NetworkStatusText text="Waiting for network..." />
			)}
			{!isLoaded && <GameProgressBar percent={loadingPercentage} />}
			{isConnected && (
				<Unity
					className="size-full"
					devicePixelRatio={devicePixelRatio}
					unityProvider={unityProvider}
				/>
			)}
		</GameWrapper>
	);
}

export default SpectatorView;
